/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type DimensionValuesRequestBody = {
  /**
   * Dataset to look in
   */
  dataset: string;
  /**
   * Dimension to list values of
   */
  dimension: string;
  /**
   * Start of the half-open window [from, to), ISO 8601
   */
  from: Date;
  /**
   * Maximum values. Defaults to 50, at most 200.
   */
  limit?: number | undefined;
  /**
   * End of the half-open window [from, to), ISO 8601
   */
  to: Date;
};

/** @internal */
export type DimensionValuesRequestBody$Outbound = {
  dataset: string;
  dimension: string;
  from: string;
  limit: number;
  to: string;
};

/** @internal */
export const DimensionValuesRequestBody$outboundSchema: z.ZodMiniType<
  DimensionValuesRequestBody$Outbound,
  DimensionValuesRequestBody
> = z.object({
  dataset: z.string(),
  dimension: z.string(),
  from: z.pipe(z.date(), z.transform(v => v.toISOString())),
  limit: z._default(z.int(), 50),
  to: z.pipe(z.date(), z.transform(v => v.toISOString())),
});

export function dimensionValuesRequestBodyToJSON(
  dimensionValuesRequestBody: DimensionValuesRequestBody,
): string {
  return JSON.stringify(
    DimensionValuesRequestBody$outboundSchema.parse(dimensionValuesRequestBody),
  );
}
